export const BEFORE_LABOR = { id: 'before_labor', label: 'Prima del travaglio' };
export const DURING_LABOR = { id: 'during_labor', label: 'Durante il travaglio' };
export const DURING_CHILDBIRTH = {
  id: 'during_childbirth',
  label: 'Durante il parto (periodo espulsivo)',
};
export const UNKNOWN = { id: 'unknown', label: 'Momento della morte ignoto' };
export const WITHIN_SEVEN_DAYS = {
  id: 'within_seven_days',
  label: 'Nato vivo e morto entro 7 giorni dal parto',
};
